import { Box, VStack, HStack, Text, Kbd, Heading } from '@chakra-ui/react';
import React from 'react';

export const KeyboardShortcutsTooltip = () => {
  const isMac = navigator.userAgent.includes('Macintosh');
  const modKey = isMac ? 'Cmd' : 'Ctrl';

  const ShortcutRow = ({
    keys,
    description,
  }: {
    keys: string[];
    description: string;
  }) => (
    <HStack spacing={2} justify="space-between" width="100%">
      <HStack spacing={1}>
        {keys.map((key) => (
          <React.Fragment key={key}>
            {key !== keys[0] && (
              <Text fontSize="xs" color="gray.600">
                +
              </Text>
            )}
            <Kbd
              fontSize="xs"
              bg="gray.100"
              borderColor="gray.400"
              borderWidth="1px"
              color="gray.800"
              fontWeight="semibold"
            >
              {key}
            </Kbd>
          </React.Fragment>
        ))}
      </HStack>
      <Text fontSize="xs" flex="1" ml={3} color="gray.700">
        {description}
      </Text>
    </HStack>
  );

  return (
    <VStack align="stretch" spacing={3} p={2} bg="white" borderRadius="md">
      <Heading size="xs" mb={1} color="gray.800">
        Shortcuts
      </Heading>

      <Box>
        <Text fontSize="xs" fontWeight="bold" mb={2} color="gray.700">
          Selection
        </Text>
        <VStack align="stretch" spacing={1.5}>
          <ShortcutRow
            keys={['Click']}
            description="Select Node/Open sidebar"
          />
          <ShortcutRow
            keys={[modKey, 'Click']}
            description="Select without opening sidebar"
          />
          <ShortcutRow
            keys={['Shift', 'Drag']}
            description="Box select multiple nodes"
          />
        </VStack>
      </Box>

      <Box>
        <Text fontSize="xs" fontWeight="bold" mb={2} color="gray.700">
          Editing
        </Text>
        <VStack align="stretch" spacing={1.5}>
          <ShortcutRow keys={[modKey, 'C']} description="Copy selected nodes" />
          <ShortcutRow keys={[modKey, 'V']} description="Paste nodes" />
          <ShortcutRow
            keys={[modKey, 'E']}
            description="Connect selected nodes"
          />
          <ShortcutRow keys={[modKey, '/']} description="Filter/search nodes" />
          <ShortcutRow keys={['Backspace']} description="Delete selection" />
        </VStack>
      </Box>
    </VStack>
  );
};
